import React from 'react';
import {ExpandImageToggle} from './utils';
import {placeholder} from '../../assets/images/images';

const ImageDisplaySection = React.memo(({title, imagesData, customFunc}) => {
  const [imageId, setImageId] = React.useState(null);
  const resizeImage = React.useCallback((id, enlarge) => {
    const img = document.getElementById(id);
    if (img) {
      if (enlarge) {
        img.classList.remove('max-h-[192px]');
      } else {
        img.classList.add('max-h-[192px]');
      }
    }
  }, []);

  return (
    <div className="mt-5">
      <div className="flex justify-between">
        {title && <p className="font-medium text-grey">{title}</p>}
      </div>
      <div
        className={`mt-4 ${
          imagesData.length > 1 ? 'flex flex-wrap gap-3' : ''
        }`}
      >
        {imagesData.map((image, index) => (
          <div
            key={index}
            className={`relative ${
              imagesData.length > 1 ? 'flex-1 min-w-[150px]' : 'w-full'
            }`}
            onMouseEnter={() => setImageId(image.id)}
            onMouseLeave={() => {
              setImageId(null);
              resizeImage(image.id, false);
            }}
          >
            {image?.desc && (
              <p className="font-medium  text-grey text-[0.55vw] bg-grey-100 px-2 py-1 rounded-full uppercase w-fit">
                {image?.desc}
              </p>
            )}

            <img
              src={image.src || placeholder}
              alt={image.alt || 'Verification Image'}
              className="w-full mt-2 object-cover max-h-[192px] rounded-md"
              id={image.id}
              onError={e => {
                e.target.src = placeholder;
              }}
            />

            {imageId === image.id && (
              <ExpandImageToggle
                customFunc={customFunc}
                resizeImage={resizeImage}
                imgUrl={image.src || placeholder}
                id={image.id}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
});

export {ImageDisplaySection};
